<!-- <div class="grid-list">
    <div class="row margin-none ">

        <div class="grid col-md-6 col-sm-12">
            <h3 class="line-bottom text-semibold">महाल शाखा</h3>
            <p>IFSC Code</p>
            <h4 class="text-semibold text-space ">KKBK0NMPK01</h4>
        </div>

        <div class="grid col-md-6 col-sm-12 n-ppost">
            <h3 class="line-bottom text-semibold">नंदनवन शाखा</h3>
            <p class=" ">IFSC Code</p>
            <h4 class="text-semibold text-space ">KKBK0NMPK02</h4>
        </div>

        <div class="grid col-md-6 col-sm-12 ">
            <h3 class="line-bottom text-semibold">पांचपावली शाखा</h3>
            <p class=" ">IFSC Code</p>
            <h4 class="text-semibold text-space ">KKBK0NMPK03</h4>
        </div>
        <div class="grid col-md-6 col-sm-12 ">
            <h3 class="line-bottom text-semibold">गांधीनगर ( सिव्हिल ) शाखा</h3>
            <p class=" ">IFSC Code</p>
            <h4 class="text-semibold text-space ">KKBK0NMPK04</h4>
        </div>
    </div>
</div> -->
<div class="grid-list">
    <div class="row">
        <div class="container">
            <div class="grid col-md-6 col-sm-12 content">
                <div class="">
                    <div class="content-overlay"></div>
                    <div class="content-image">
                        <h3 class="line-bottom text-semibold">महाल शाखा</h3>
                        <p>IFSC Code</p>
                        <h4 class="text-semibold text-space ">KKBK0NMPK01</h4>
                    </div>
                    <div class="content-details fadeIn-top">
                        <p class="title-big">मुख्य शाखा, कोठी रोड, टाऊन हॉल जवळ, महाल नागपूर. - ४४००३२.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="grid col-md-6 col-sm-12 content">
                <div class="">
                    <div class="content-overlay"></div>
                    <div class="content-image">
                        <h3 class="line-bottom text-semibold">नंदनवन शाखा</h3>
                        <p class=" ">IFSC Code</p>
                        <h4 class="text-semibold text-space ">KKBK0NMPK02</h4>
                    </div>
                    <div class="content-details fadeIn-top">
                        <p class="title-big">भांडे प्लॉट चौक, पालटकर भवन. - ४४००२४.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="grid col-md-6 col-sm-12 content">
                <div class="">
                    <div class="content-overlay"></div>
                    <div class="content-image">
                        <h3 class="line-bottom text-semibold">पांचपावली शाखा</h3>
                        <p class=" ">IFSC Code</p>
                        <h4 class="text-semibold text-space ">KKBK0NMPK03</h4>
                    </div>
                    <div class="content-details fadeIn-top">
                        <p class="title-big">कमाल चौक, पाली भवन. - ४४००१७.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="grid col-md-6 col-sm-12 content">
                <div class="">
                    <div class="content-overlay"></div>
                    <div class="content-image">
                        <h3 class="line-bottom text-semibold">गांधीनगर ( सिव्हिल ) शाखा</h3>
                        <p class=" ">IFSC Code</p>
                        <h4 class="text-semibold text-space ">KKBK0NMPK04</h4>
                    </div>
                    <div class="content-details fadeIn-top">
                        <p class="title-big">N. M. C. मुख्यलयाच्या आवारात, Bank Of Maharashtra जवळ. - ४४०००१.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>